import { FC, useCallback, useMemo } from "react";
import { useAppSelector } from "../../../../store";

import { StateAction } from "../../../../helpers/functions/types";
import { GingerTeaCampaignData, HandleCampaignChange } from "../../../types";
import { BadgedText } from "../../../../ui/layout/organisms/BadgedText/BadgedText";
import {
  allGingerTeaSuggestedClasses,
  gingerTeaSuggestedClasses,
} from "./constants";

type GingerTeaManualClassesProps = {
  isModal?: boolean;
  gingerTeaManualClasses?: string[];
  handleChange: HandleCampaignChange;
  setGingerTeaProps: StateAction<GingerTeaCampaignData>;
};
export const GingerTeaManualClasses: FC<GingerTeaManualClassesProps> = ({
  isModal,
  gingerTeaManualClasses,
  handleChange,
  setGingerTeaProps,
}) => {
  const industry = useAppSelector((state) => state.company.company?.industry);

  const relevantSuggestions = useMemo(() => {
    const relevantKey = industry as keyof typeof gingerTeaSuggestedClasses;
    if (relevantKey && gingerTeaSuggestedClasses[relevantKey]) {
      return { [relevantKey]: gingerTeaSuggestedClasses[relevantKey] };
    }
    return gingerTeaSuggestedClasses;
  }, [industry]);

  const allSuggestions = useMemo(
    () => Object.values(relevantSuggestions).flat(),
    [relevantSuggestions],
  );

  const gingerTeaCustomClasses = useMemo(
    () =>
      (gingerTeaManualClasses ?? []).filter(
        (item) => !allSuggestions.includes(item) && item.trim() !== "",
      ),
    [gingerTeaManualClasses, allSuggestions],
  );

  const handleManualClasses = useCallback(
    (newClasses: string[]) => {
      setGingerTeaProps((gingerTeaProps) => ({
        ...gingerTeaProps,
        gingerTeaManualClasses: newClasses,
      }));
      handleChange(
        "gingerTeaManualClasses",
        false,
      )(newClasses.filter((item) => item.trim() !== ""));
    },
    [handleChange, setGingerTeaProps],
  );

  return (
    <BadgedText
      title="Manual Classes"
      customActiveData={gingerTeaCustomClasses}
      currentActiveData={gingerTeaManualClasses ?? []}
      handleBadgedData={handleManualClasses}
      predefinedValuesGroups={relevantSuggestions}
      isModal={isModal}
      fullList={allGingerTeaSuggestedClasses}
      inputPlaceholder="a unicorn"
      textareaPostscript="'a mirror' and 'a window' are not recommended."
    />
  );
};
